import { useCallback } from 'react'

import { useSegment } from '../../../../../hooks'
import { invoicingViewTrackingLocationMap } from '../../../constants/invoicingViewTrackingLocationMap'
import { SendAsEmailModalVariant } from '../../../enums/sendAsEmailModalVariant'
import { useSendAsEmailForm } from '../contexts/sendAsEmailFormContext'
import { useSendAsEmailModal } from '../contexts/sendAsEmailModalContext'

export const useTrackSendAsEmail = () => {
  const { track } = useSegment()
  const { documentType, invoiceNumber, view } = useSendAsEmailModal()
  const { variant } = useSendAsEmailForm()

  const trackSendAsEmail = useCallback(
    (eventDetail: string, payload?: Record<string, any>) => {
      const isSendInvoiceAsEmailModal = variant === SendAsEmailModalVariant.Invoice
      const modalName = isSendInvoiceAsEmailModal ? 'Send as email' : 'Send payment reminder'
      const modalLocation = invoicingViewTrackingLocationMap[view]

      track(
        `XXX - Invoicing Core - ${modalLocation} - ${modalName} - ${eventDetail}`,
        isSendInvoiceAsEmailModal ? { documentType, invoiceNumber, ...payload } : undefined,
      )
    },
    [documentType, invoiceNumber, track, variant, view],
  )

  return { trackSendAsEmail }
}
